import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_artisan_candles: FaireThemeEntity = {
  token: "discovery_theme_artisan-candles",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Artisan Candles & Scents",
  description: "Small-batch candles and fragrances",
  bgColor: "#F0E6D8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
